module.exports = __webpack_public_path__ + "static/media/calabashNormalHero.0ab74b40.png";